// Import of creatApp from Vue 3 bundler and axios for API requests.
import { createApp } from 'vue/dist/vue.esm-bundler';
import mixin from '../mixin.js';
import axios from 'axios';

import bulmaCollapsible from '@creativebulma/bulma-collapsible';

const productionApp = {
    mixins: [mixin],
    // The data object returns data-attribute values instantiated in HTML and general properties for loading state, 
    // the nested data object with resulting items.
    data() {
        return {
            dataApi: '',
            dataLimit: 10, // Default limit in BE
            dataSortKey: '',
            dataSortDirection: '',
            dataProductionId: null,
            dataEventId: null,
            dropdownOpen: false,
            loading: true,
            data: null,
            event: null
        }
    },
    // The computed property holds reactive properties for orderItems, filterItems and the queryModel are kept track of.
    computed: {
        orderItems() {
            if (!this.dataSortKey && !this.dataSortDirection) return [];
            return [
                {
                    Key: this.dataSortKey,
                    Direction: this.dataSortDirection,
                }
            ]
        },
        filterItems() {
            if (!this.dataProductionId) return [];
            return [{
                Key: 'productionProviderId',
                Values: [this.dataProductionId],
                Operator: 'Eq',
            }]
        },
        queryModel() {
            return {
                OrderItems: this.orderItems,
                FilterItems: this.filterItems,
            }
        }
    },
    methods: {
        // The fetchData method fetches and handles API data. 
        fetchData() {
            axios
                .post(this.dataApi, this.queryModel)
                .then(response => {
                    if (response.status === 200) {
                        this.data = response.data;

                        if (this.data.items && this.data.items.length) {
                            if (this.dataEventId && this.data.items.some(item => item.id === this.dataEventId)) {
                                this.event = this.data.items.find(item => item.id === this.dataEventId);
                            }
                            else {
                                this.event = this.data.items[0];
                            }
                        }
                    }
                })
                .catch(error => console.log(error))
                // Set loading prop to false when done.
                .finally(() => {
                    this.loading = false;
                            
                });
        },
        // Data alteration function for reloading data with set filters.
        selectOption(value) {
            let newUrl = window.location.origin + window.location.pathname + "?eventId=" + value;
            this.redirect(newUrl);
        },
        redirect(url) {
            if (url) window.location.href = url;
        },
        // Simple price int handler for outputting formatted price.
        toPrice(priceInt) {
            return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(priceInt);
        },
        setCappedRef(el) {
            if (el && !this.cappedElements.includes(el)) {
                this.cappedElements.push(el);
            }
        },
        getElement(ref) {
            return ref instanceof HTMLElement ? ref : ref?.$el instanceof HTMLElement ? ref.$el : null;
        }
    },
    created() {
        this.cappedElements = [];
    },
    beforeUpdate() {
        this.cappedElements = [];
    },
    mounted() {
        // Set data props according to data attributes in HTML template.
        if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
        if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
        if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
        if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;

        if (this.$el.dataset.productionid) this.dataProductionId = this.$el.dataset.productionid;
        if (this.$el.dataset.eventid) this.dataEventId = this.$el.dataset.eventid;

        // Initial data fetch.
        this.fetchData();
    },
    updated() {
        bulmaCollapsible.attach('.is-vue-collapsible');

        this.cappedElements.forEach(element => {
            const elementMaxHeight = element.dataset.maxHeight ? parseInt(element.dataset.maxHeight) : 290;
            const buttonElement = element.parentNode.querySelector('.reading-button');
            const orgHeight = element.scrollHeight;
            if (orgHeight > elementMaxHeight && buttonElement) {
                element.classList.add('is-capped');
                buttonElement.classList.remove('is-hidden');
                buttonElement.addEventListener('click', () => {
                    element.classList.toggle('is-capped');
                    element.style.maxHeight = element.classList.contains('is-capped') ?  elementMaxHeight + 'px' : orgHeight + 'px';
                    if (buttonElement.getElementsByClassName('text').length) {
                        const buttonText = buttonElement.getElementsByClassName('text')[0];
                        buttonText.innerHTML = element.classList.contains('is-capped') ? buttonText.dataset.readMore : buttonText.dataset.readLess;
                    }
                });
            }
        });
    }
};

export default productionApp;